<template>
  <div class="orangehrm-horizontal-padding orangehrm-vertical-padding">
    <oxd-text tag="h6" class="orangehrm-main-title">
      Edit Project Pay Rate
    </oxd-text>

    <oxd-divider />

    <oxd-form :loading="isLoading" @submit-valid="onSave">
      <oxd-form-row>
        <oxd-grid :cols="3" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <project-autocomplete
              v-model="clientRate.project"
              :rules="rules.project"
              required
            />
          </oxd-grid-item>

          <oxd-grid-item>
            <oxd-input-field
              v-model="clientRate.rateType"
              type="select"
              label="Rate Type"
              :options="rateTypes"
              :rules="rules.rateType"
              required
            />
          </oxd-grid-item>

          <oxd-grid-item>
            <oxd-input-field
              v-model="clientRate.rate"
              label="Rate"
              :rules="rules.rate"
              required
            />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>

      <oxd-form-row>
        <oxd-grid :cols="3" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <oxd-text tag="p"> Active </oxd-text>

            <oxd-switch-input v-model="clientRate.active" />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>

      <oxd-form-actions>
        <required-text />

        <oxd-button
          type="button"
          display-type="ghost"
          :label="$t('general.cancel')"
          @click="onCancel"
        />

        <submit-button />
      </oxd-form-actions>
    </oxd-form>
  </div>

  <oxd-divider />
</template>

<script>
import {
  digitsOnlyWithDecimalPoint,
  required,
  validSelection,
} from '@ohrm/core/util/validation/rules';

import {OxdSwitchInput} from '@ohrm/oxd';

import ProjectAutocomplete from '@/orangehrmTimePlugin/components/ProjectAutocomplete.vue';

export default {
  name: 'EditClientPayRate',

  components: {
    'project-autocomplete': ProjectAutocomplete,
    'oxd-switch-input': OxdSwitchInput,
  },

  props: {
    http: {
      type: Object,
      required: true,
    },

    data: {
      type: Object,
      required: true,
    },
  },

  emits: ['close'],

  data() {
    return {
      isLoading: false,

      clientRate: {
        project: {
          id: this.data.projectId,
          label: this.data.project,
        },

        rateType: {
          id: this.data.rateType,
          label: this.data.rateType === 'DAILY' ? 'Daily' : 'Hourly',
        },

        rate: String(this.data.rate ?? ''),

        active: this.data.rawActive,
      },

      rateTypes: [
        {
          id: 'HOURLY',
          label: 'Hourly',
        },
        {
          id: 'DAILY',
          label: 'Daily',
        },
      ],

      rules: {
        project: [required, validSelection],
        rateType: [required],
        rate: [required, digitsOnlyWithDecimalPoint],
      },
    };
  },

  methods: {
    onSave() {
      this.isLoading = true;

      this.http
        .update(this.data.id, {
          projectId: this.clientRate.project?.id,
          rateType: this.clientRate.rateType?.id,
          rate: Number(this.clientRate.rate),
          active: this.clientRate.active,
        })
        .then(() => {
          return this.$toast.updateSuccess();
        })
        .then(() => {
          this.onCancel();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    onCancel() {
      this.$emit('close', true);
    },
  },
};
</script>
